import React from 'react';

const PageIntroSection = ({title,text,image}) => {
    return (
        <div className='page-intro-section'>
            {image && <img src={image} alt=""/>}
            <div className="center-wrapper flex-column">
                <h1>{title}</h1>
                <p>{text}</p>
            </div>
            <div className="cover"></div>
        </div>
    );
};

export default PageIntroSection;